import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { SxProps, Theme, useTheme } from "@mui/material/styles";
import { mergeSx } from "merge-sx";

interface Props {
  testId?: string;
  onClick: () => void;
  className?: string;
  sx?: SxProps<Theme>;
  disabled?: boolean;
}

export const CloseButton: React.FC<Props> = ({
  testId,
  className,
  disabled,
  onClick,
  sx,
}) => {
  const theme = useTheme();

  return (
    <IconButton
      data-testid={testId}
      className={className}
      onClick={onClick}
      disabled={disabled}
      size="large"
      sx={mergeSx(
        {
          border: "1px solid",
          borderColor: theme.palette.divider,
          height: theme.spacing(5),
          width: theme.spacing(5),
        },
        sx
      )}>
      <CloseIcon />
    </IconButton>
  );
};
